import {css} from 'styled-components';
import {IMarginProps, IPaddingProps} from './commonTypes';

export const margins = css<IMarginProps>`
  ${({margin}) => margin && `margin: ${margin};`}
  ${({marginLeft}) => marginLeft && `margin-left: ${marginLeft};`}
  ${({marginRight}) => marginRight && `margin-right: ${marginRight};`}
  ${({marginTop}) => marginTop && `margin-top: ${marginTop};`}
  ${({marginBottom}) => marginBottom && `margin-bottom: ${marginBottom};`}
`;

export const paddings = css<IPaddingProps>`
  ${({padding}) => padding && `padding: ${padding};`}
  ${({paddingLeft}) => paddingLeft && `padding-left: ${paddingLeft};`}
  ${({paddingRight}) => paddingRight && `padding-right: ${paddingRight};`}
  ${({paddingTop}) => paddingTop && `padding-top: ${paddingTop};`}
  ${({paddingBottom}) => paddingBottom && `padding-bottom: ${paddingBottom};`}
`;
